import { Assets, Button } from '@nexds/web'
import { useTheme } from 'styled-components'

import {
  Actions,
  AppErrorFallbackVariant,
  CloseButton,
  Container,
  Content,
  Message,
  Title
} from './AppErrorFallback.styles'

interface AppErrorFallbackProps {
  onAction: () => void
  onClose: () => void
  title: string
  message: string
  actionLabel: string
  variant?: AppErrorFallbackVariant
}

function AppErrorFallback(props: AppErrorFallbackProps) {
  const { onAction, onClose, title, message, actionLabel, variant = 'fullscreen' } = props

  const theme = useTheme()

  return (
    <Container $variant={variant}>
      <Content $variant={variant}>
        <CloseButton aria-label="Fechar erro" onClick={onClose}>
          <Assets.Close size="md" color={theme.colors.secondaryL3} />
        </CloseButton>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <Actions>
          <Button label={actionLabel} size="sm" color="primary" variant="filled" fullWidth onPress={onAction} />
        </Actions>
      </Content>
    </Container>
  )
}

export { AppErrorFallback }
